import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";

/**
 * The open outgoing invoices a payment of the incoming invoice can be offset against — those of
 * the projects whose client is its contact, with what each still owes, net, and the other open
 * invoice one is planned against. The route answers 403 to a caller who may not edit outgoing
 * invoices; callers pass `isEnabled` only for one who may, and a refusal stays quiet rather than
 * toasting.
 *
 * @param incomingInvoiceId - The incoming invoice whose payment is offset.
 * @param isEnabled - Whether to ask at all.
 */
export function useIncomingInvoiceOffsetCandidates(incomingInvoiceId: string, isEnabled = true) {
	/** Query */
	const query = useQuery({
		queryKey: ["incoming-invoices", incomingInvoiceId, "offset-candidates"],
		queryFn: async () => {
			const response = await client.incoming_invoices[":incomingInvoiceId"][
				"offset-candidates"
			].$get({ param: { incomingInvoiceId } });
			const data = await responseHandler(response, false);
			return data.candidates;
		},
		enabled: isEnabled,
		retry: false,
	});

	/** Return */
	return { ...query, candidates: query.data ?? [] };
}
